<template>
  <div class="stats-list">
    <div class="stats-data">
      <StatsItem
        :data="data"
        v-for="data in statsData"
        :key="data.name"
        class="stats-data__item"
      ></StatsItem>
    </div>
  </div>
</template>

<script>
import StatsItem from './StatsItem';
import toUpperCase from '../../../filters/toUpperCase.js';
import mixin from '../../../utils/mixin';

export default {
  mixins: [mixin],
  data: function() {
    return {
      riskLevel: 'TBA'
    };
  },
  computed: {
    statsData() {
      const data = this.accumulativeStatsData;

      if (!data) {
        return [
          {
            name: 'Your network',
            delta: 0,
            value: '-',
            month: 'latest 30 days',
            lastMonth: 'previous period',
            lastValue: '-'
          },
          {
            name: 'Your economy',
            delta: 0,
            value: '-',
            month: 'latest 30 days',
            lastMonth: 'previous period',
            lastValue: '-'
          },
          {
            name: 'Your region',
            delta: 0,
            value: '-',
            month: 'latest 30 days',
            lastMonth: 'previous period',
            lastValue: '-'
          }
        ];
      }
      return [
        {
          name: 'Your network',
          delta: data.asn.delta,
          value: data.asn.current,
          month: data.thisMonth,
          lastMonth: data.lastMonth,
          lastValue: data.asn.last
        },
        {
          name: this.getNameByType('economy'),
          delta: data.economy.delta,
          value: data.economy.current,
          month: data.thisMonth,
          lastMonth: data.lastMonth,
          lastValue: data.economy.last
        },
        {
          name: this.getNameByType('region'),
          delta: data.region.delta,
          value: data.region.current,
          month: data.thisMonth,
          lastMonth: data.lastMonth,
          lastValue: data.region.last
        }
      ];
    }
  },
  filters: {
    toUpperCase
  },
  components: { StatsItem }
};
</script>

<style scoped lang="scss">
.stats-list {
  .stats-data {
    display: flex;
    font-size: 0.75rem !important;

    &__item {
      border-right: 2px solid $apnic-blue;

      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        border: none;
        padding-right: 0;
      }

      @include media-breakpoint-down(md) {
        border-bottom: 2px solid $apnic-blue;
        border-right: 0px;

        padding-left: 0;
        padding-right: 0;
      }
    }

    @include media-breakpoint-down(md) {
      flex-direction: column;
    }
  }
}
</style>
